import { render, staticRenderFns } from "./StandardReportForm.vue?vue&type=template&id=a36f264e&scoped=true"
import script from "./StandardReportForm.vue?vue&type=script&lang=js"
export * from "./StandardReportForm.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/_appointment-report.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./StandardReportForm.vue?vue&type=style&index=1&id=a36f264e&prod&lang=scss&scoped=true"
import style2 from "./StandardReportForm.vue?vue&type=style&index=2&id=a36f264e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36f264e",
  null
  
)

export default component.exports